import axios from 'axios'

const IBGE_BASE_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades'

export interface IBGEMunicipio {
  id: number
  nome: string
}

export const getCitiesByState = async (uf: string): Promise<IBGEMunicipio[]> => {
  if (!uf) return []
  const response = await axios.get<IBGEMunicipio[]>(
    `${IBGE_BASE_URL}/estados/${uf}/municipios?orderBy=nome`
  )
  return response.data
}
